<template>
  <div v-if='this.$config["Html With Markdown"].AboutDeal' v-html="compiledMarkdown"></div>
  <div v-else class="content">
    <h1>{{ this.$config["Product Name"] }}软件许可及服务协议</h1>
    <h2>
      服务协议条款的确认提醒
    </h2>

    <p>
      欢迎你使用{{ this.$config["Product Name"] }}软件及服务！
    </p>
    <p>
      <strong>
        为使用{{ this.$config["Product Name"] }}软件（以下简称“本软件”）及服务，你应当阅读并遵守《{{
          this.$config["Product Name"]
        }}软件许可及服务协议》（以下简称“本协议”）。请你务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，并选择接受或不接受。限制、免责条款可能以加粗形式提示你注意。
      </strong>
    </p>
    <p>
      <strong>
        除非你已阅读并接受本协议所有条款，否则你无权下载、安装或使用本软件及相关服务。你的下载、安装、使用、获取{{ this.$config["Product Name"] }}帐号、登录等行为即视为你已阅读并同意上述协议的约束。
      </strong>
    </p>
    <p>
      <strong>
        如果你未满18周岁，请在法定监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。
      </strong>
    </p>
    <h2>
      一、协议范围
    </h2>
    <h2>
      1.1协议适用主体范围
    </h2>
    <p>
      本协议是你与{{ this.$config["Product Name"] }}之间关于你下载、安装、使用、复制本软件，以及使用{{ this.$config["Product Name"] }}相关服务所订立的协议。
    </p>
    <h2>
      1.2协议更新
    </h2>
    <p>
      本协议约定{{ this.$config["Product Name"] }}与用户之间关于“{{ this.$config["Product Name"] }}”软件服务（以下简称“服务”）的权利义务。“用户”是指注册、
      登录、使用本服务的个人。<strong>本协议可由{{ this.$config["Product Name"] }}随时更新，
      更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知。 </strong>用户可在{{
        this.$config["Product Name"]
      }}软件的”关于“中查阅最新版协议条款。在{{
        this.$config["Product Name"]
      }}修改协议条款后，如果用户不接受修改后的条款，请立即停止使用{{ this.$config["Product Name"] }}提供的服务，用户继续使用{{
        this.$config["Product Name"]
      }}提供的服务将被视为接受修改后的协议。
    </p>
    <h2>
      二、服务内容
    </h2>
    <p>
      2.1本服务内容是指{{ this.$config["Product Name"] }}向用户提供的完成返利任务而获取奖励收益的赚钱工具（以下简称“{{
        this.$config["Product Name"]
      }}”）；具体服务内容由{{ this.$config["Product Name"] }}根据实际情况提供，包括但不限于：
    </p>
    <p>
      2.1.1广告播放：用户安装运行“{{ this.$config["Product Name"] }}”软件后可以在软件界面观看广告；
    </p>
    <p>
      2.1.2返利任务：用户安装运行“{{ this.$config["Product Name"] }}”软件后，可以在客户端内，获取的{{
        this.$config["Product Name"]
      }}与第三方供应商、合作伙伴提供的广告信息。部分广告信息以任务返利的形式呈现给用户。包括但不限于下载应用、浏览广告信息；
    </p>
    <p>
      2.1.3钱币制：根据任务要求，完成任务的用户可获得奖励；
    </p>
    <p>
      2.1.4钱币兑换：用户可以使用所获钱币兑换{{ this.$config["Product Name"] }}的合作供应商所提供的商品及服务。
    </p>
    <p>
      <strong>2.2在遵守相关法律法规前提下，根据合作广告主的要求，{{ this.$config["Product Name"] }}有权决定用户在“{{
          this.$config["Product Name"]
        }}”软件界面上看到的广告内容。</strong>
    </p>
    <p>
      <strong>2.3用户使用获得的钱币能够兑换的商品及服务的种类与兑换价格由{{ this.$config["Product Name"] }}全权决定。</strong>
    </p>
    <h2>
      三、软件使用规则
    </h2>
    <h2>
      3.1软件的获取
    </h2>
    <p>
      3.1.1你可以直接从得到{{ this.$config["Product Name"] }}授权的第三方获取；
    </p>
    <p>
      <strong>3.1.2 如果你从未经{{ this.$config["Product Name"] }}授权的第三方获取本软件或与本软件名称相同的安装程序，{{
          this.$config["Product Name"]
        }}无法保证该软件能够正常使用，并对因此给你造成的损失不予负责。</strong>
    </p>
    <h2>
      3.2软件的安装与卸载
    </h2>
    <p>
      3.2.1 {{ this.$config["Product Name"] }}可能为不同的终端设备开发了不同的软件版本，你应当根据实际情况选择下载合适的版本进行安装。
    </p>
    <p>
      3.2.2 下载安装程序后，你需要按照该程序提示的步骤正确安装。
    </p>
    <p>
      3.2.3 如果你不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果你愿意帮助{{ this.$config["Product Name"] }}改进产品服务，请告知卸载的原因。
    </p>
    <h2>
      3.3软件的更新
    </h2>
    <p>
      3.3.1 为了改善用户体验、完善服务内容，{{ this.$config["Product Name"] }}将不断努力开发新的服务，并为你不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）
    </p>
    <p>
      3.3.2 为了保证本软件及服务的安全性和功能的一致性，{{ this.$config["Product Name"] }}有权不经向你特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。
    </p>
    <p>
      <strong>
        3.3.3 本软件新版本发布后，旧版本的软件可能无法使用。{{ this.$config["Product Name"] }}不保证旧版本软件继续可用及相应的客户服务，请你随时核对并下载最新版本。
      </strong>
    </p>

    <h2>
      四、账号注册
    </h2>
    <p>
      4.1用户在使用本服务前需要注册一个“{{ this.$config["Product Name"] }}”账号。“{{ this.$config["Product Name"] }}”账号应当使用手机号码绑定注册，
      请用户使用尚未与“{{ this.$config["Product Name"] }}”账号绑定的手机号码，以及未被{{
        this.$config["Product Name"]
      }}根据本协议封禁的手机号码注册“{{ this.$config["Product Name"] }}”账号。
      {{ this.$config["Product Name"] }}可以根据用户需求或产品需要对账号注册和绑定的方式进行变更，而无须事先通知用户。
    </p>
    <p>
      4.2用户没有完成手机号注册流程，仍然继续使用“{{
        this.$config["Product Name"]
      }}”软件，系统将自动为该用户分配一个邀请码，该邀请码无需用配套密码登陆。用户需在30天内（自首次生成邀请码起）完成该邀请码与手机号的绑定，未完成手机号绑定的，{{
        this.$config["Product Name"]
      }}有权回收该帐号，以免造成资源浪费，由此带来的任何损失均由用户自行承担。
    </p>
    <p>
      4.3如果注册申请者有被{{ this.$config["Product Name"] }}封禁的先例或涉嫌虚假注册及滥用他人名义注册，及其他不能得到许可的理由，{{
        this.$config["Product Name"]
      }}将拒绝其注册申请。
    </p>
    <p>
      4.4注册成功后，用户可以通过“{{ this.$config["Product Name"] }}”软件中“我的账号”界面浏览或更改本人的个人信息。 但不能修改系统自动分配给用户的ID-“邀请码”。
    </p>
    <p>
      4.5用户注册时所填写的个人信息如有变动，用户需通过“我的账号”界面及时更改。 用户因未及时更改造成的损失{{ this.$config["Product Name"] }}概不负责。
    </p>
    <p>
      <strong>
        4.6{{ this.$config["Product Name"] }}账号的权归{{
          this.$config["Product Name"]
        }}所有，用户完成申请注册手续后，仅获得{{
          this.$config["Product Name"]
        }}账户的使用权，且该使用权仅属于初始申请注册人。同时，初始申请注册人不得赠与、借用、租用、转让或售卖{{
          this.$config["Product Name"]
        }}账号或者以其他方式许可非初始申请注册人使用{{
          this.$config["Product Name"]
        }}账号。非初始申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用{{ this.$config["Product Name"] }}账号。
      </strong>
    </p>
    <p>
      4.7用户注册{{ this.$config["Product Name"] }}账号后如果长期不登录该帐号，{{
        this.$config["Product Name"]
      }}有权回收该帐号，以免造成资源浪费，由此带来的任何损失均由用户自行承担。
    </p>
    <h2>
      五、完成任务，累计钱币
    </h2>
    <p>
      5.1运行“{{ this.$config["Product Name"] }}”软件后，按照任务要求完成解锁、下载应用等均可获取钱币。
    </p>
    <p>
      <strong>
        5.2完成所有的体验任务，都需要连接网络；因包括但不限于网络稳定等问题而导致任务完成失败，未获得钱币，{{ this.$config["Product Name"] }}不会补发钱币。
      </strong>
    </p>
    <p>
      5.3部分需提交截图证明的任务，{{ this.$config["Product Name"] }}有权对任务截图进行审核，并根据你提交的任务截图对任务完成的结果做出通过或者不通过的评定。
    </p>
    <p>
      5.4你可以在“{{ this.$config["Product Name"] }}”软件中查看你获取的钱币情况。“{{
        this.$config["Product Name"]
      }}”软件中显示的累计钱币数量可能与{{ this.$config["Product Name"] }}服务器端存在统计差异，实际钱币数量以服务器端为准。
    </p>
    <p>
      5.5用户钱币作为“{{ this.$config["Product Name"] }}”软件中的虚拟记录符号，不能在用户间相互转让，
      不能使用包括人民币在内的任何法定货币购买，不具有在“{{ this.$config["Product Name"] }}”软件以外的环境中进行交易结算的功能。
    </p>
    <p>
      5.6如果用户的累计钱币数量出现错误，用户可以自出现错误之日起90天以内向{{ this.$config["Product Name"] }}提出更正要求， {{
        this.$config["Product Name"]
      }}如果确定该用户的要求为正当合理，应在用户提出要求之日起90天以内更正错误。
    </p>
    <h2>
      六、钱币兑换
    </h2>
    <p>
      <strong>
        6.1用户使用钱币兑换商品及服务后，如出现商品及服务的质量问题，由{{ this.$config["Product Name"] }}合作商负责解决，{{
          this.$config["Product Name"]
        }}不承担相关责任。由此产生的纠纷及诉讼与{{ this.$config["Product Name"] }}无关。
      </strong>
    </p>
    <p>
      6.2用户只有完成手机号注册流程且绑定一个已实名认证的支付宝账号之后才能用获得的钱币兑换上述商品及服务。 仅有用户ID-邀请码而未完成手机号绑定的用户无法进行钱币兑换。
    </p>
    <h2>
      七、用户个人信息保护
    </h2>
    <p>
      7.1{{ this.$config["Product Name"] }}未经用户同意不向任何第三方公开、透露用户个人隐私信息。但以下特定情形除外：
    </p>
    <p>
      7.1.1 {{ this.$config["Product Name"] }}根据法律法规规定或有权机关的指示提供用户的个人隐私信息；
    </p>
    <p>
      7.1.2由于用户将其用户密码告知他人或与他人共享注册帐户与密码，由此导致的任何个人信息的泄漏， 或其他非因{{ this.$config["Product Name"] }}原因导致的个人隐私信息的泄露；
    </p>
    <p>
      7.1.3用户自行向第三方公开其个人隐私信息；
    </p>
    <p>
      7.1.4用户与{{ this.$config["Product Name"] }}及合作单位之间就用户个人隐私信息的使用公开达成约定， {{
        this.$config["Product Name"]
      }}因此向合作单位公开用户个人隐私信息；
    </p>
    <p>
      7.1.5何由于黑客攻击、电脑病毒侵入及其他非因{{ this.$config["Product Name"] }}原因导致用户个人隐私信息的泄露。
    </p>
    <p>
      7.2用户同意{{ this.$config["Product Name"] }}可在以下事项中使用用户的个人隐私信息：
    </p>
    <p>
      7.2.1 向用户及时发送重要通知，如软件更新、本协议条款的变更；
    </p>
    <p>
      7.2.2 {{ this.$config["Product Name"] }}内部进行审计、数据分析和研究等，以改进{{ this.$config["Product Name"] }}的产品、服务和与用户之间的沟通；
    </p>
    <p>
      7.2.3 依本协议约定，{{ this.$config["Product Name"] }}管理、审查用户信息及进行处理措施；
    </p>
    <p>
      7.2.4适用法律法规规定的其他事项。
    </p>
    <p>
      <strong>
        7.3你在注册帐号或使用本服务的过程中，需要提供一些必要的信息，例如：你进行兑换时，需要你提供已实名认证的支付宝账号；若你提供的信息不完整，则无法使用本服务或在使用过程中受到限制。
      </strong>
    </p>
    <p>
      7.4{{ this.$config["Product Name"] }}非常重视对未成年人个人信息的保护。若你是18周岁以下的未成年人，在使用{{
        this.$config["Product Name"]
      }}的服务前，应事先取得你家长或法定监护人的书面同意。
    </p>
    <h2>
      八、主权利义务条款
    </h2>
    <h2>
      8.1 账户使用规范
    </h2>
    <p>
      8.1.1用户有责任妥善保管注册帐户信息及帐户密码的安全，用户需要对注册帐户以及密码下的行为承担法律责任。用户同意在任何情况下不向他人透露帐户及密码信息。当在你怀疑他人在使用你的帐号时，你应立即通知{{
        this.$config["Product Name"]
      }}公司。
    </p>
    <p>
      <strong>
        8.1.2用户在安装{{
          this.$config["Product Name"]
        }}后，尽快完成手机号注册流程，因未完成邀请码与手机号的绑定而造成的账户钱币丢失，{{ this.$config["Product Name"] }}对此不负任何责任。
      </strong>
    </p>
    <p>
      <strong>
        8.1.3长期不运行“{{ this.$config["Product Name"] }}”软件且未完成手机号注册流程的用户（非活跃用户）所获得钱币自动被清零。
        长期不运行指1个月（30天）内没有运行“{{ this.$config["Product Name"] }}”软件，即没有在“{{ this.$config["Product Name"] }}”软件内进行任何操作。
      </strong>
    </p>
    <h2>
      8.2用户注意事项
    </h2>
    <p>
      8.2.1你理解并同意：为了向你提供有效的服务，本软件会利用你终端设备的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。
    </p>
    <p>
      8.2.2你理解并同意{{ this.$config["Product Name"] }}将会尽其商业上的合理努力保障你在本软件及服务中的数据存储安全，但是，{{
        this.$config["Product Name"]
      }}并不能就此提供完全保证，包括但不限于以下情形：
    </p>
    <p>
      8.2.2.1 {{ this.$config["Product Name"] }}不对你在本软件及服务中相关数据的删除或储存失败负责；
    </p>
    <p>
      8.2.2.2 {{
        this.$config["Product Name"]
      }}有权根据实际情况自行决定单个用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。你可根据自己的需要自行备份本软件及服务中的相关数据；
    </p>
    <p>
      8.2.2.3 如果你停止使用本软件及服务或服务被终止或取消，{{
        this.$config["Product Name"]
      }}可以从服务器上永久地删除你的数据。服务停止、终止或取消后，{{ this.$config["Product Name"] }}没有义务向你返还任何数据。
    </p>
    <p>
      8.2.3用户在使用本软件及服务时，须自行承担如下来自{{ this.$config["Product Name"] }}不可掌控的风险内容，包括但不限于：
    </p>
    <p>
      8.2.3.1 由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；
    </p>
    <p>
      8.2.3.2由于无线网络信号不稳定、无线网络带宽小等原因，所引起的{{ this.$config["Product Name"] }}登录失败、页面打开速度慢等风险。
    </p>
    <h2>
      九、用户使用规范
    </h2>
    <p>
      9.1{{ this.$config["Product Name"] }}用户不能利用{{ this.$config["Product Name"] }}账号或者{{
        this.$config["Product Name"]
      }}提供的服务进行如下行为：
    </p>
    <p>
      9.1.1利用科技手段批量建立虚假账号；
    </p>
    <p>
      9.1.2侵害{{ this.$config["Product Name"] }}以及第三者的知识产权；
    </p>
    <p>
      9.1.3提交、发布虚假信息，或者盗用他人资料，冒充、利用他人名义；
    </p>
    <p>
      9.1.4未经{{ this.$config["Product Name"] }}许可，而传播广告或淫秽暴力等信息；
    </p>
    <p>
      9.1.5其他不遵守本协议的行为；
    </p>
    <p>
      9.1.6其他违法以及不正当的行为；
    </p>
    <p>
      <strong>
        9.2如果用户采用擅自更改“{{
          this.$config["Product Name"]
        }}”软件程序或通过刷机刷量等技术手段邀请虚假用户或在没有充分告知其他潜在用户的情况下使得该潜在用户虽然安装了“{{
          this.$config["Product Name"]
        }}”软件但没有正常使用行为的或使用黑客手段攻击{{ this.$config["Product Name"] }}服务器等不正当手段来获取钱币，
        {{ this.$config["Product Name"] }}视为用户作弊行为而有权取消该用户资格并删除该用户所有钱币， 并保留对攻击{{
          this.$config["Product Name"]
        }}服务器等黑客行为追究法律责任的权力。
      </strong>
    </p>
    <p>
    <h2>
      十、免责条款
    </h2>
    <p>
      <strong>
        10.1{{ this.$config["Product Name"] }}提供的服务中包括，用户同意在使用过程中显示{{
          this.$config["Product Name"]
        }}与第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责，
        对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，{{ this.$config["Product Name"] }}不承担任何责任。
      </strong>
    </p>
    <p>
      <strong>
        10.2当用户接受该协议时，用户应当明确了解并同意：
      </strong>
    </p>
    <p>
      <strong>
        （1）“{{
          this.$config["Product Name"]
        }}”软件程序不能随时预见到任何技术上的问题或其他困难。该等困难可能会导致数据损失或其他服务中断。“{{
          this.$config["Product Name"]
        }}”软件程序是在现有技术基础上提供的服务。“{{ this.$config["Product Name"] }}”软件程序不保证以下事项∶
        A、“{{ this.$config["Product Name"] }}”软件程序将符合所有用户的要求； B、“{{
          this.$config["Product Name"]
        }}”软件程序不受干扰、能够及时提供、安全可靠或免于出错； C、本服务使用权的取得结果是正确或可靠的。
      </strong>
    </p>
    <p>
      <strong>
        （2）是否经由“{{
          this.$config["Product Name"]
        }}”软件程序下载或取得任何资料，由用户自行考虑、衡量并且自负风险，因下载任何资料而导致用户手机的任何损坏或资料流失，用户应负完全责任。希望用户在使用“{{
          this.$config["Product Name"]
        }}”软件程序时，小心谨慎并运用常识；
      </strong>
    </p>
    <p>
      <strong>
        （3）用户经由“{{ this.$config["Product Name"] }}”软件程序取得的广告、建议和资讯，无论其形式或表现，绝不构成本协议未明示规定的任何保证；
      </strong>
    </p>
    <p>
      <strong>
        （4）基于以下原因而造成的利润、商誉、使用、资料损失或其它无形损失，“{{
          this.$config["Product Name"]
        }}”软件程序不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿（即使“{{ this.$config["Product Name"] }}”软件程序已被告知前款赔偿的可能性）：
        A、“{{ this.$config["Product Name"] }}”软件程序的使用或无法使用；
        B、用户的传输或资料遭到未获授权的存取或变更；
        C、“{{ this.$config["Product Name"] }}”软件程序中任何第三方之声明或行为；
        D、“{{ this.$config["Product Name"] }}”软件程序在服务交易中为用户提供的广告所导致的行为；
        E、“{{ this.$config["Product Name"] }}”软件程序其它相关事宜。
      </strong>
    </p>
    <p>
      <strong>
        （5）“{{
          this.$config["Product Name"]
        }}”软件程序只是为用户提供一个展示服务平台，对于第三方供应商、合作伙伴提供的广告合法性、真实性及其品质，“{{ this.$config["Product Name"] }}”软件程序一律不负任何担保责任；
      </strong>
    </p>
    <p>
      <strong>
        （6）“{{
          this.$config["Product Name"]
        }}”软件程序提供与其它互联网上的网站或资源的链接，用户可能会因此连结至其它运营商经营的网站，但不表示“{{
          this.$config["Product Name"]
        }}”软件程序与这些运营商有任何关系。其它运营商经营的网站均由各经营者自行负责，不属于“{{
          this.$config["Product Name"]
        }}”软件程序控制及负责范围之内。对于存在或来源于此类网站或资源的任何内容、广告、物品或其它资料，“{{
          this.$config["Product Name"]
        }}”软件程序亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、物品或服务所产生的任何损害或损失，“{{
          this.$config["Product Name"]
        }}”软件程序不负任何直接或间接的责任。
      </strong>
    </p>
    <h2>
      十一、服务的变更、中断、终止
    </h2>
    <p>
      11.1因设备维修或更换、故障和通信中断等技术原因而中断业务，{{ this.$config["Product Name"] }}可视情况事前或事后通知用户。
    </p>
    <p>
      11.2如果因{{ this.$config["Product Name"] }}临时中断业务而导致用户钱币数据丢失，{{ this.$config["Product Name"] }}会给予丢失数据的用户相应的钱币补偿，
      具体补偿钱币数量由{{ this.$config["Product Name"] }}决定。但因不可抗力导致的业务中断发生时,{{ this.$config["Product Name"] }}不给予用户补偿。
    </p>
    <p>
      11.3当{{ this.$config["Product Name"] }}用户发生如下情况时，{{
        this.$config["Product Name"]
      }}可单方面终止本协议，取消用户继续使用{{ this.$config["Product Name"] }}产品及服务的资格：
    </p>
    <p>
      11.3.1 用户死亡；
    </p>
    <p>
      11.3.2盗用他人的个人信息或手机；
    </p>
    <p>
      11.3.3 注册用户时提供虚假信息；
    </p>
    <p>
      11.3.4 以非法手段（包括且不限于黑客攻击等）来积累或使用钱币；
    </p>
    <p>
      11.3.5 妨碍其他用户的正常使用；
    </p>
    <p>
      11.3.6 伪称是{{ this.$config["Product Name"] }}的工作人员或管理人员；
    </p>
    <p>
      11.3.7擅自强行更改{{ this.$config["Product Name"] }}的计算机系统，或威胁侵入系统；
    </p>
    <p>
      11.3.8 擅自传播谣言，用各种手段来毁损{{ this.$config["Product Name"] }}的名誉与妨碍{{ this.$config["Product Name"] }}的正常营业；
    </p>
    <p>
      11.3.9利用{{ this.$config["Product Name"] }}的产品及服务宣传垃圾广告；
    </p>
    <p>
      11.3.10其他违反本协议的行为及违法行为。
    </p>
    <p>
      11.3.11 用户如因上述第11.3.1条原因而被取消用户资格，用户法定财产继承人可在用户资格被取消之日起30日内向{{
        this.$config["Product Name"]
      }}提出书面申请，将该用户剩余钱币转移至自己所有的{{ this.$config["Product Name"] }}账号下， 否则{{ this.$config["Product Name"] }}有权删除该用户剩余钱币。
    </p>
    <p>
      11.3.12 用户如因上述第11.3.2条到11.3.10条的原因而被取消用户资格，{{ this.$config["Product Name"] }}有权立即删除该用户的全部钱币。
    </p>
    <h2>
      十二、知识产权声明
    </h2>
    <p>
      12.1
      {{
        this.$config["Product Name"]
      }}是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，{{
        this.$config["Product Name"]
      }}享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
    </p>
    <p>
      12.2未经{{ this.$config["Product Name"] }}或相关权利人书面同意，你不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。
    </p>
    <h2>
      十三、其他
    </h2>
    <p>
      13.1 本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和{{ this.$config["Product Name"] }}之间发生任何纠纷或争议，
      首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交{{ this.$config["Product Name"] }}住所地有管辖权的人民法院管辖。
    </p>
    <p>
      13.2本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。
    </p>
    <p>
      13.3本协议的版权由{{ this.$config["Product Name"] }}所有，{{ this.$config["Product Name"] }}保留一切解释和修改的权力。
    </p>
    <p>
      13.4本协议从2016年12月1日起适用。
    </p>

  </div>
</template>

<script>
import marked from 'marked'

export default {
  name: "AboutDeal",
  data() {
    return {
      data: {}
    }
  },
  beforeCreate() {
    document.title = this.$config["Product Name"] + " - 用户协议"
  },
  mounted() {
    if (this.$config["Html With Markdown"].AboutDeal) {
      this.markdown()
    }
  },
  methods: {
    markdown() {
      marked.setOptions({
        renderer: new marked.Renderer(),
        gfm: true,
        tables: true,
        breaks: false,
        pedantic: false,
        sanitize: false,
        smartLists: true,
        smartypants: false
      });
    }
  },
  computed: {
    compiledMarkdown() {
      return marked(this.$config["Html With Markdown"].AboutDeal, {sanitize: true})
    }
  }
}
</script>
